<style media="print">
  @page {
    margin-left: 0cm;
    margin-right: 0cm;
  }

    .invoice {
        page-break-inside: auto; /* allow breaking inside for first one */
        break-inside: auto;
    }

    /* First invoice → behave like a normal block */
    .invoice:first-child {
        display: block !important;
        min-height: auto !important;
        page-break-before: auto !important;
        page-break-after: auto !important;
        justify-content: normal !important;
        flex: none !important;
    }

    /* All invoices after the first → forced page per invoice */
    .invoice:not(:first-child) {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        min-height: calc(100vh - 2mm); /* force fill page */
        page-break-after: always;
        /*page-break-before: always;
        break-before: page;*/
        page-break-inside: avoid;
        break-inside: avoid;
    }

    /* Last invoice → no extra blank trailing page */
    .invoice:last-child {
        page-break-after: auto !important;
        break-after: auto !important;
        margin-bottom: 0 !important;
    }

 

</style>

<div class="container-fluid">
    <div class="row align-items-center mb-3 hidden-print">
        <div class="col-md-6">
        <h2 class="fw-bold mb-0">AP Statement Report</h2>
        </div>

        <div class="col-md-6 text-md-end mt-2 mt-md-0">
        <button
            pButton
            icon="pi pi-refresh"
            label="REFRESH"
            class="btn btn-primary btn-sm me-2"
            (click)="getReportDetails()">
        </button>

        <button
            pButton
            icon="pi pi-print"
            label="PRINT"
            class="btn btn-danger btn-sm"
            (click)="printReportDetails()">
        </button>
        </div>
    </div>
    
    <!-- FILTER CARD -->
    <div class="card shadow-sm mb-4">
    <div class="card-body">

    <div class="row g-3 hidden-print">

      <!-- Date Range -->
      <div class="col-md-3 col-sm-12">
        <div class="form-group">
        <input id="DateRange"
                #Product_IsActive="ngModel"
                name="DateRange"
                [(ngModel)]="dateRangeSelected"
                (click)="OnselectDateRange($event)"
                type="checkbox"
                class="form-check-input" />
          <span class="form-check-label">
            {{ l('DateRange') }}
          </span>
           <p-calendar *ngIf="dateRangeSelected" [(ngModel)]="dateRange"
                        selectionMode="range"
                        dateFormat="dd-mm-yy"
                        inputStyleClass="form-control">
            </p-calendar>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
            <label class="form-label fw-semibold">Vendor</label>
            <p-multiSelect
              [options]="vendors"
              optionLabel="displayName"
              optionValue="id"
              display="chip"
              [(ngModel)]="selectedVendors"
              appendTo="body"
              style="width: 100%"
              class="w-100">
            </p-multiSelect>
          </div>
        </div>
    </div>

    </div>
    </div>
 <!-- LOADER -->
  <div *ngIf="loading" class="text-center p-4">
    <i class="fa fa-spinner fa-spin fa-3x"></i>
  </div>

    <!-- TABLE -->
  <div *ngFor="let purchaseReportOutputItem of purchaseReportOutput.invoices" class="invoice">
    <div class="row">
      <div class="col-md-12">
        <h2 class="text-center"> {{ companyDetails.name }}</h2>
        <h4 class="text-center"> {{ locationDetails.address1 + ' ' +  locationDetails.address2 }}</h4>
        <h4 class="text-center"> {{ locationDetails.country + ' ' +  locationDetails.postalCode }}</h4>
      </div>
    </div>
    <div class="row">
        <h3 class="text-center">Statement Of Accounts</h3>
    </div>
    <div class="row">
        <div>
          {{ purchaseReportOutputItem.vendorName }}
        </div>
        <div>
          {{ purchaseReportOutputItem.address1 }}
        </div>
        <div>
          {{ purchaseReportOutputItem.address2 }}
        </div>
        <div>
          {{ purchaseReportOutputItem.country + ' ' +  purchaseReportOutputItem.postalCode }}
        </div>
        <div>
          Contact - {{ purchaseReportOutputItem.phoneNo }}
        </div>
    </div>
    <div class="table-responsive">
      <table class="table table-bordered table-hover">
        <thead>
          <tr>
            <th>Date</th>
            <th>Type</th>
            <th>Invoice No.</th>
            <th>Reference</th>
            <th>Debit</th>
            <th>Credit</th>
            <th>Balance</th>
          </tr>
        </thead>
        <tbody *ngFor="let item of purchaseReportOutputItem.items">
          <tr >
            <td >{{ item.transactionDate | luxonFormat: this.dateFormat}}</td>
            <td >{{ item.strType }}</td>
            <td >{{ item.invoiceNo }}</td>
            <td >{{ item.referenceNo }}</td>
            <td class="text-end">{{ item.amount | number:'1.2-2'}}</td>
            <td class="text-end">{{ item.paidAmount | number:'1.2-2'}}</td>
            <td class="text-end">{{ item.cumulativeAmount | number:'1.2-2'}}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr class="table-dark text-white">
            <td></td>
            <td></td>
            <td></td>
            <td class="text-center fw-bold">Total</td>
            <td></td>
            <td></td>
            <td class="text-end fw-bold">
              {{ purchaseReportOutputItem.totalOutstanding | number:'1.2-2' }}
            </td>
          </tr>
        </tfoot>

      </table>
    </div>

  </div>

</div>